import { put, takeLatest } from 'redux-saga/effects';

import CustomerService from '../../../services/CustomerService';
import {
  getCustomerListRequest,
  getCustomerListSuccess,
  getCustomerListFail,
  getCustomerRequest,
  getCustomerSuccess,
  getCustomerFail,
  saveCustomerRequest,
  saveCustomerSuccess,
  saveCustomerFail,
  initCustomerRequest,
  initCustomerSuccess,
  initCustomerFail,
  createCustomerRequest,
  createCustomerSuccess,
  createCustomerFail,
  deleteCustomerRequest,
  deleteCustomerSuccess,
  deleteCustomerFail,
  setCustomerListDirty,
  clearCustomerList,
} from './actions';
import { logOut } from '../auth/actions';
import { apiCall } from '../../effects';
import { getErrorNotification } from '../../util';
import { notify } from '../notifications/actions';

function* getCustomersList({
  payload,
}: ReturnType<typeof getCustomerListRequest>) {
  try {
    const list = yield apiCall(CustomerService.list, payload);
    yield put(getCustomerListSuccess(list));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getCustomerListFail());
  }
}

function* getCustomer({ payload }: ReturnType<typeof getCustomerRequest>) {
  try {
    const response = yield apiCall(CustomerService.get, payload);
    yield put(getCustomerSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getCustomerFail());
  }
}

function* saveCustomer({ payload }: ReturnType<typeof saveCustomerRequest>) {
  try {
    const response = yield apiCall(CustomerService.save, payload.id, payload);
    yield put(saveCustomerSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(saveCustomerFail());
  }
}

function* getTemplateCustomer(){
  try {
    const response = yield apiCall(CustomerService.template);
    yield put(initCustomerSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(initCustomerFail());
  }
}

function* createCustomer({ payload }: ReturnType<typeof createCustomerRequest>) {
  try {
    const response = yield apiCall(CustomerService.create, payload);
    yield put(createCustomerSuccess(response));
  } catch (e) {
    yield put(initCustomerSuccess(payload));
    yield put(notify(getErrorNotification(e)));
    yield put(createCustomerFail());
  }
}

function* deleteCustomer({ payload }: ReturnType<typeof deleteCustomerRequest>) {
  try {
    yield apiCall(CustomerService.delete, payload);
    yield put(deleteCustomerSuccess());
    yield put(setCustomerListDirty(true));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(deleteCustomerFail());
  }
}

function* clearList() {
  yield put(clearCustomerList());
}

export default [
  takeLatest(getCustomerListRequest.type, getCustomersList),
  takeLatest(getCustomerRequest.type, getCustomer),
  takeLatest(saveCustomerRequest.type, saveCustomer),
  takeLatest(initCustomerRequest.type, getTemplateCustomer),
  takeLatest(createCustomerRequest.type, createCustomer),
  takeLatest(deleteCustomerRequest.type, deleteCustomer),
  takeLatest(logOut.type, clearList),
];
